<template>
  <div class="service-support">
    <banner clazz="service-support-banner" url="serviceSupport">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        <!--        <el-button class="banner-button" round @click="goRegister(1)">申请体验</el-button>-->
      </template>
    </banner>
    <div class="service-support-section1">
      <el-tabs type="border-card" class="service-support-tab" v-model="tabValue">
        <el-tab-pane name="first">
          <h1 class="service-support-tabpane" slot="label">我们的服务</h1>
          <div class="service">
            <div class="region1">
              <h2 class="region1-title">我们如何帮助您？</h2>
              <div class="region1-divider"></div>
              <p class="region1-detial">
                甄云提供全流程开发运维服务，帮助企业内部IT能力从面向工具到面向服务的转型，采用前沿技术快速迭代，适应供应链业务前沿需求，涵盖服<br/>
                务器、存储、网络、操作系统、应用、中间件及虚拟化的一揽子解决方案，运维专家团队全天候监控、诊断并修复异常，我们的专业服务团队为<br/>
                您提供实施运维服务。</p>
            </div>
            <div class="region2">
              <div class="region2-content">
                <h1 class="region2-title">服务流程</h1>
                <div class="region2-divider"></div>
                <div class="region2-flow">
                  <ul class="flow-ul clearfix">
                    <li class="flow-li fl" v-for="(item, index) in flowData" :key="index">
                      <h2>{{item.title}}</h2>
                      <p>{{item.detail}}</p>
                    </li>
                  </ul>
                </div>
                <div class="region2-detail">
                  <div class="detail-shadow"></div>
                  <img class="detail-img" src="../../assets/img/serviceSupport/tab1-region2-2.png" alt="服务流程">
                  <div class="detail-content">
                    <h1 class="detail-title">无论何时何地，只要您需要，都可以获得支持</h1>
                    <div class="detail-divider"></div>
                    <p class="detail">
                      当您遇到问题、需求和挑战时，我们都有专人为您服务，<br/>
                      保障您问题的及时有效解决，我们很自豪能够成为提供这种<br/>
                      个性化支持的提供商。 </p>
                  </div>
                  <div class="detail-contact">
                    我们每一步都与您同在。请致电<span class="phone-number"> 400-116-0808 </span>与我们联系，或留下您的信息，我们
                    <button class="arrange-demo" @click="goRegister('fuwuzhichi-yanshi')">安排演示。</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <h1 class="service-support-tabpane" slot="label">资料库及常见问题</h1>
          <div class="exchange">
            <div class="region1">
              <h2 class="region1-title">资料库</h2>
              <div class="region1-divider"></div>
              <h2 class="region1-detial">提供行业资讯、采购干货资源下载</h2>
              <div class="region1-content clearfix">
                <div class="content content-left fl">
                  <p class="content-detail">定期发布行业资讯<br/>
                    <br/>
                    采购行业相关干货资源<br/>
                    <br/>
                    白皮书、调研报告解读<br/>
                    <br/>
                    在这里，能够让您获得更多有价值的资讯</p>
                </div>
                <div class="content content-right fl">
                  <img class="content-img" src="../../assets/img/serviceSupport/tab3-region1.png" alt="采购行业相关干货资源">
                </div>
              </div>
              <div class="region1-buttons">
                <el-button class="banner-button" @click="goDocument" round>资料下载</el-button>
              </div>
            </div>
            <div class="region2">
              <div class="title">
                <h1 class="region2-title">常见问题</h1>
                <div class="region2-divider"></div>
                <div class="region2-search">
                  <el-input v-model="keyword" placeholder="搜索答案" @keyup.enter.native="goSearchAnswer"></el-input>
                  <el-button icon="el-icon-search" @click="goSearchAnswer"></el-button>
                </div>
              </div>
              <div class="content" v-if="tableData.pages">
                <!--<ul class="content-region clearfix">-->
                <!--<li class="content-mian fl" v-for="(item, index) in tableData.question" :key="index">-->
                <!--<div class="content-titile">{{item.subject}}</div>-->
                <!--<p class="content-detail">-->
                <!--{{item.answer}}-->
                <!--</p>-->
                <!--</li>-->
                <!--</ul>-->
                <el-collapse class="tl content-collapse" v-model="activeNames">
                  <el-collapse-item v-for="(item, index) in tableData.question" :name="index" :key="index">
                    <template slot="title">
                      <h1 class="collapse-title">
                        <img class="question-icon" src="../../assets/img/serviceSupport/Q.png" :alt="item.subject">{{item.subject}}
                      </h1>
                    </template>
                    <div class="collapse-answer">
                      <img class="answer-icon" src="../../assets/img/serviceSupport/A.png" :alt="item.answer">
                      <p class="answer-detail">{{item.answer}}</p>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <el-button icon="el-icon-refresh" @click="goChange"> 换一批</el-button>
              </div>
              <div v-else class="content-undefined">
                <p class="undefined-detail">Sorry！很抱歉，我们暂无关于“{{ keywordShow }}”的相关信息，请您重新输入搜索信息</p>
                <p class="undefined-phone">或拨打热线：400-116-0808</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'ServiceSupport',
  metaInfo () {
    return {
      title: this.$seo.servicesupport.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.servicesupport.keywords
      },
      {
        name: 'description',
        content: this.$seo.servicesupport.description
      }]
    }
  },
  components: {
    banner
  },
  data () {
    return {
      flowData: [{
        title: '快速响应',
        detail: '第一时间响应您的需求快速帮您解决问题'
      },
      {
        title: '专属服务',
        detail: '专业客服经理实时在线，一对一服务'
      },
      {
        title: '拜访客户',
        detail: '达成意向后，公司安排专业顾问经理上门演示系统及功能'
      },
      {
        title: '技术支持',
        detail: '培训使用技巧，提供专业服务保障，确保客户使用顺畅'
      },
      {
        title: '售后保障',
        detail: '服务问题及时解决与反馈， 保障客户软件稳定运行'
      }],
      keyword: '', // 搜索条件
      keywordShow: '', // 未搜索到报信息
      totalPage: '', // 总页数
      currentPage: 1, // 默认当前页
      tabValue: 'first',
      tableData: {
        cur_page: '1',
        pages: 2,
        question: [{
          answer: '不是，产品支持云部署和私有化部署，私有化部署也可以部署在腾讯云的私有服务器上。',
          id: '1',
          subject: '产品是否仅支持云部署？'
        }, {
          answer: '不是，产品支持云部署和私有化部署，私有化部署也可以部署在腾讯云的私有服务器上。',
          id: '2',
          subject: '产品是否仅支持云部署？'
        }, {
          answer: '不是，产品支持云部署和私有化部署，私有化部署也可以部署在腾讯云的私有服务器上。',
          id: '3',
          subject: '产品是否仅支持云部署？'
        }]
      }, // 列表展示,
      activeNames: ['1']
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    },
    // 第二列
    getCaseData () {
      this.$api.post('/cases/get_cases', { webname: 'serviceSupport', cases_sum: '' }, (r) => {
        if (r.code === 0) {
          this.caseData = r.data
          this.caseData.forEach(i => {
            i.scenarios = i.scenarios.split('@')
            var typeData = []
            for (var j = 0, len = i.scenarios.length; j < len; j += 1) {
              typeData.push(i.scenarios.slice(j, j + 1))
            }
            typeData.forEach(item => {
              item.push('')
            })
            i.scenarios = [].concat.apply([], typeData)
            if (i.scenarios[i.scenarios.length - 1] === '') {
              i.scenarios = i.scenarios.slice(0, -1)
            }
          })
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 第三列
    // 跳转文档中心
    goDocument () {
      this.$router.push('/dataDownload')
    },
    // 搜索答案
    goSearchAnswer () {
      this.currentPage = 1
      this.SearchAnswer()
    },
    SearchAnswer () {
      this.$api.post('/Support/usually_question', {
        counts: 5,
        page: this.currentPage,
        keyword: this.keyword
      }, (r) => {
        if (r.code === 0) {
          this.tableData = r.data
          if (!this.tableData.pages) {
            this.keywordShow = this.keyword
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 换一批
    goChange () {
      this.activeNames = []
      if (this.currentPage >= this.tableData.pages) {
        this.currentPage = 1
      } else {
        this.currentPage = this.currentPage + 1
      }
      this.SearchAnswer()
    }
  },
  mounted () {
    this.goSearchAnswer()
    console.log(this.$route)
    if (this.$route.params.IsShow) {
      this.tabValue = 'second'
    }
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/serviceSupport.scss";
</style>



// WEBPACK FOOTER //
// serviceSupport.vue?55cf535c